import { useContentOverflow } from '../../../../hooks'
import { FloatingTooltip, FloatingTooltipContentText } from '../../../Floating'
import { SelectDropdownEntityListItemContentInfoAdditionalData } from '../SelectDropdownEntityListItemContentInfoAdditionalData'
import { SelectDropdownEntityListItemContentInfoText } from '../SelectDropdownEntityListItemContentInfoText'

import {
  getEntityListItemTooltip,
  getEntityListItemTooltipPlacement,
} from './SelectDropdownEntityListItemContentInfo.utils'

import * as styles from './SelectDropdownEntityListItemContentInfo.module.css'

function SelectDropdownEntityListItemContentInfo({
  ContentAdditionalData = SelectDropdownEntityListItemContentInfoAdditionalData,
  ContentText = SelectDropdownEntityListItemContentInfoText,
  className = styles.SelectDropdownEntityListItemContentInfo,
  contentTextProps,
  disabled,
  getTooltip = getEntityListItemTooltip,
  getTooltipPlacement = getEntityListItemTooltipPlacement,
  isActive,
  isFocused,
  isHovered,
  listExtraText,
  tooltipPlacement,
  value,
}) {
  const {
    overflow: overflowText,
    setContentOverflowRef: setTextContentOverflowRef,
  } = useContentOverflow()

  const {
    overflow: overflowAdditionalData,
    setContentOverflowRef: setAdditionalDataContentOverflowRef,
  } = useContentOverflow()

  const tooltipContent = getTooltip(value)

  const tooltipItemPlacement = getTooltipPlacement(value)

  const tooltipProps =
    disabled && tooltipContent
      ? {
          content: tooltipContent,
          placement: tooltipItemPlacement || tooltipPlacement,
        }
      : {
          content: (
            <FloatingTooltipContentText
              additionalText={value.additionalData}
              text={value.label}
            />
          ),
          disabled: !overflowText && !overflowAdditionalData,
        }

  return (
    <FloatingTooltip {...tooltipProps}>
      <div className={className}>
        {ContentText ? (
          <ContentText
            {...contentTextProps}
            disabled={disabled}
            isActive={isActive}
            isFocused={isFocused}
            isHovered={isHovered}
            listExtraText={listExtraText}
            ref={setTextContentOverflowRef}
            value={value}
          />
        ) : null}
        {ContentAdditionalData ? (
          <ContentAdditionalData
            disabled={disabled}
            isActive={isActive}
            isFocused={isFocused}
            isHovered={isHovered}
            ref={setAdditionalDataContentOverflowRef}
            value={value}
          />
        ) : null}
      </div>
    </FloatingTooltip>
  )
}

export default SelectDropdownEntityListItemContentInfo
